import React from "react"
import {FieldViewProps} from "../../../../render/view";
import DropdownValueSmall from "../../components/dropdown-value-small";


export default function FieldDropdown_ViewSmall(props: FieldViewProps) {

    const value = props.model[props.field.fieldId]

    const option = props.field._getOption(value)

    return <DropdownValueSmall className={props.className} option={option} field={props.field} />

}